export default __webpack_public_path__ + "static/media/DocPlaceColor.81cbd331.svg";